/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ToolNameplateExportBody } from '../models/ToolNameplateExportBody';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ToolNameplatesService {
    /**
     * export tool nameplates as pdf
     * @param requestBody
     * @returns binary successful
     * @throws ApiError
     */
    public static exportToolNameplates(
        requestBody?: ToolNameplateExportBody,
    ): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/resources/tool_administration/nameplates/export',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
